import { render, staticRenderFns } from "./forget-box.vue?vue&type=template&id=51970647&scoped=true&"
import script from "./forget-box.vue?vue&type=script&lang=js&"
export * from "./forget-box.vue?vue&type=script&lang=js&"
import style0 from "./forget-box.vue?vue&type=style&index=0&id=51970647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51970647",
  null
  
)

export default component.exports